import state from './moduleFileState.js'
import mutations from './moduleFileMutation.js'
import actions from './moduleFileActions.js'
import getters from './moduleFileGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

